import { render, staticRenderFns } from "./InvoiceInboundsFinance.vue?vue&type=template&id=af47a7a6&"
import script from "./InvoiceInboundsFinance.vue?vue&type=script&lang=js&"
export * from "./InvoiceInboundsFinance.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports